import React from "react";

// Small key explaining the live-traffic route colours. Render only when traffic data exists.
export default function TrafficLegend({ className = "" }) {
  const items = [
    { c: "#16A34A", label: "Clear" },
    { c: "#F59E0B", label: "Slow" },
    { c: "#DC2626", label: "Heavy" },
  ];
  return (
    <div className={`inline-flex items-center gap-3 rounded-full bg-white/95 px-3 py-1.5 text-xs shadow-md shadow-ink/10 backdrop-blur ${className}`} data-testid="traffic-legend">
      <span className="font-semibold text-ink-soft">Traffic</span>
      {items.map((i) => (
        <span key={i.label} className="inline-flex items-center gap-1 text-ink-soft">
          <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: i.c }} />
          {i.label}
        </span>
      ))}
    </div>
  );
}
